export class SubscriptionOption {
  public id?: number;
  public text?: string;
  public isActive?: boolean;
  public dbRowVersion?: string;
}
